var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHotMatchBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2217 1.92969L9.94531 2.82324L8 0L6.05469 2.82324L2.77832 1.92969L3.0752 5.36133L0 6.81641L2.40039 9.25098L0.964844 12.373L4.34473 12.6719L5.22168 16L8 14.0225L10.7783 16L11.6553 12.6719L15.0352 12.373L13.5996 9.25098L16 6.81641L12.9248 5.36133L13.2217 1.92969Z",
    fill: "url(#paint0_linear_7266_17348)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 8.77863V8.12995C11.5 7.84287 11.2566 7.61111 10.9545 7.61111H9.72736C9.42643 7.61111 9.18182 7.84379 9.18182 8.12963C9.18182 8.41596 9.42599 8.64815 9.72687 8.64815H9.86344C9.93938 8.64815 10 8.70673 10 8.77899V9.03582C10 9.1092 9.93886 9.16667 9.86344 9.16667H9.72687C9.21884 9.16667 8.79182 8.83613 8.67073 8.38889H7.00102C6.92485 8.38889 6.86364 8.33031 6.86364 8.25804V8.00121C6.86364 7.92784 6.92514 7.87037 7.00102 7.87037H8.67081C8.79205 7.42342 9.21931 7.09259 9.72736 7.09259H10.8182V6.96264C10.8182 5.60265 9.65808 4.5 8.22748 4.5H8.09071C6.65942 4.5 5.5 5.60189 5.5 6.96318V8.90606C5.5 9.37047 5.65184 10.0739 5.84421 10.5009L5.85554 10.5231L6.59091 11.5H9.86364L11.0379 10.1017C11.2713 9.8374 11.5 9.17012 11.5 8.77863Z",
    fill: "#EBF9FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7266_17348",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3575FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotMatchBadge);
export default __webpack_public_path__ + "static/media/icon-hot-match-badge.13dcb7004ecdb408c2eb6a5527f28578.svg";
export { ForwardRef as ReactComponent };